
import markerSDK from '@marker.io/browser'
import Global from '@/mixins/Global'

export default {
  head: {
    script: [
      {
        hid: 'fb-pixel',
        innerHTML: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '369484360474723');
          fbq('track', 'PageView');
        `,
        type: 'text/javascript',
        charset: 'utf-8',
      },
    ],
    noscript: [
      {
        innerHTML: '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=369484360474723&ev=PageView&noscript=1"/>',
      },
    ],
    __dangerouslyDisableSanitizers: ['script'],
  },
  mixins: [Global],
  mounted () {
    this.updateBodyBackground(this.$route.path)
  },
  methods: {
    updateBodyBackground (path) {
      if (path.includes('/announcement')) {
        document.body.style.backgroundColor = '#E5E2DF'
      } else {
        document.body.style.backgroundColor = ''
      }
    },
  },
  async created () {
    if (process.env.NODE_ENV === 'staging') {
      const widget = await markerSDK.loadWidget({
        destination: process.env.MARKERIO_DESTINATION, // <- Your unique destination ID
      })
      widget.setReporter({ email: this.email, fullName: this.name })
    }
  },
}
